import map from "lodash/map";
import each from "lodash/each";
import isEqual from "lodash/isEqual";

export const returnSlideArrayWithGroupedSlidesAdjusted = (
  slideArray,
  existingSlideArray,
  groupedSlideIds,
  total_duration_ms
) => {
  console.log("returnSlideArrayWithGroupedSlidesAdjusted", total_duration_ms);
  // First, check that any changes do not modify the number of slides.
  if (existingSlideArray.length != slideArray.length) {
    return slideArray;
  }

  // Find slide that moved and its time delta.
  var existingTimings = map(existingSlideArray, "timing");
  var newTimings = map(slideArray, "timing");

  // If timings are equal, just return the slideArray here.
  if (isEqual(existingTimings, newTimings)) {
    return slideArray;
  }

  var changedTimingIndex = null;
  var changedTimingIndexDelta = 0;
  each(existingTimings, (time, idx) => {
    //console.log(time, newTimings[idx]);
    if (time != newTimings[idx]) {
      //console.log("Slide idx", idx, "changed!");
      changedTimingIndex = idx;
      changedTimingIndexDelta = newTimings[idx] - time;
      //console.log("changedTimingIndex", changedTimingIndex);
      //console.log("changedTimingIndexDelta", changedTimingIndexDelta);
    }
  });

  if (!changedTimingIndex) {
    return slideArray;
  }

  // We found a changed timing.

  var changedSlideId = slideArray[changedTimingIndex].id;

  if (groupedSlideIds.includes(changedSlideId)) {
    // Is that slide in a group.
    console.log("Moved slide is in group!");
    // Move all slides by that delta.
    each(slideArray, s => {
      if (groupedSlideIds.includes(s.id) && s.id != changedSlideId) {
        s.timing = s.timing + changedTimingIndexDelta;
      }
    });
    // Return new slide array.
  }
  return slideArray;
};
